<template>
  <b-checkbox-group v-model="selected" @input="$emit('input', $event)" :options="options" :state="state"/>
</template>

<script>
import baseInput from './_base'

export default {
  mixins: [baseInput],

  props: {
    options: { type: Array },
  },

  data() {
    return {
      selected: this.value,
    }
  },

  watch: {
    value(newVal) {
      this.selected = newVal
    },
  },
}
</script>

<style lang="scss">
.live-input--checkboxes {
  padding-top: 1rem;
  font-size: $font-size-sm;

  .form-error, .form-label {
    left: 0;
  }

  .custom-control {
    padding-left: 1.25rem;
  }

  .custom-control-label::before {
    left: -1.3rem;
    width: 0.9rem;
    height: 0.9rem;
    top: 0.15rem;
  }

  .custom-control-label::after {
    left: -1.35rem;
    top: 0.15rem
  }
}
</style>